const sqidString = ":sqid";

export const getAdminAudienceEditPathsV2 = ({
  sqid = sqidString,
}: {
  sqid?: string;
}) => {
  const adminAudienceBasePath = `/settings/admin/audience/${sqid}`;

  return {
    index: adminAudienceBasePath,
    info: `${adminAudienceBasePath}/info`,
    access: `${adminAudienceBasePath}/access`,
    billing: `${adminAudienceBasePath}/billing`,
    activityLogs: `${adminAudienceBasePath}/activity_logs`,
    notes: `${adminAudienceBasePath}/notes`,
    gamification: `${adminAudienceBasePath}/gamification`,
    affiliate: `${adminAudienceBasePath}/affiliate`,
    newSubscription: `${adminAudienceBasePath}/billing/subscriptions/new`,
  };
};
